"use strict";
var googleReviews = document.querySelector('.google-reviews');
if (googleReviews) {
    var statsUrl_1 = "https://ccd-typescript-api-5341184e38bc.herokuapp.com/googlereviews/stats";
    fetch(statsUrl_1, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "x-api-key": "fda7b8af-a2ec-4609-895e-12f4bee2cf05"
        },
    }).then(function (response) {
        response.json().then(function (json) {
            var _a;
            var data = json.data;
            if (data && data.averageRating && data.totalReviews) {
                var averageRating = data.averageRating;
                var totalReviews = data.totalReviews || 0;
                var averageRatingElement = googleReviews.querySelector('.average-rating');
                var reviewCountElement = googleReviews.querySelector('.review-count');
                if (averageRatingElement) {
                    averageRatingElement.textContent = averageRating || "";
                    (_a = document.querySelector('.google-reviews .google-stars')) === null || _a === void 0 ? void 0 : _a.setAttribute('data-rating', averageRating);
                    setGoogleReviewsStars('.google-reviews .google-stars', 25);
                }
                if (reviewCountElement) {
                    reviewCountElement.textContent = totalReviews + " reviews";
                }
            }
        });
    }).catch(function (error) {
        console.log(error);
    });
    var reviewsUrl = "https://ccd-typescript-api-5341184e38bc.herokuapp.com/googlereviews/list";
    fetch(reviewsUrl, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "x-api-key": "fda7b8af-a2ec-4609-895e-12f4bee2cf05"
        },
    }).then(function (response) {
        response.json().then(function (json) {
            var reviews = json.data || [];
            var reviewsBlockWrapper = googleReviews.querySelector('.google-reviews-splide .splide__list');
            if (reviewsBlockWrapper) {
                var htmlBlock = '';
                for (var index = 0; index < reviews.length; index++) {
                    var review = reviews[index];
                    var textLength = (review.review_text || '').length;
                    var reviewText = (review.review_text || '').substring(0, 100) + (textLength > 100 ? "..." : "");
                    var addReadMore = textLength > 100;
                    htmlBlock += "\n            <div class=\"splide__slide review-item\" data-index=\"".concat(index, "\">\n              <div class=\"google-stars stars\" data-rating=\"").concat(review.review_rating, "\"></div>\n              <div class=\"review-body\">\n                <p data-short-text=\"").concat(reviewText, "\" data-text=\"").concat(review.review_text || '', "\"><span>").concat(reviewText, "</span> ").concat((addReadMore) ? "<button class=\"button-no-style\" onclick=\"handleReadMore(".concat(index, ")\" target=\"_blank\">Read more</button>") : '', "</p>\n              </div>\n              <div class=\"review-meta d-flex\">\n                <img src=\"").concat(review.author_image, "\" alt=\"").concat(review.author_title, "\" loading=\"lazy\" />\n                <div class=\"d-flex align-items-start justify-content-center flex-1 flex-column\">\n                  <div class=\"reviewer-name\">").concat(review.author_title, "</div>\n                  <div class=\"review-date\">").concat(displayTimeAgo(review.review_timestamp), "</div>\n                </div>\n              </div>\n            </div>\n          ");
                }
                reviewsBlockWrapper.innerHTML = htmlBlock;
                setGoogleReviewsStars('.google-reviews .review-item .google-stars', 25);
                // @ts-ignore
                new Splide('.google-reviews-splide', {
                    perPage: 1,
                    perMove: 1,
                    type: 'loop',
                    gap: "15px",
                    padding: {
                        left: "0",
                        right: "0"
                    },
                    pagination: true,
                    arrows: true,
                    breakpoints: {
                        991: {
                            perPage: 1,
                            padding: {
                                left: "25px",
                                right: "25px"
                            },
                        }
                    }
                }).mount();
            }
        });
    }).catch(function (error) {
        console.log(error);
    });
}
function setGoogleReviewsStars(selector, starWidth) {
    var elements = document.querySelectorAll(selector);
    elements.forEach(function (element) {
        var rating = Math.round(parseFloat(element.getAttribute('data-rating') || "5"));
        var width = Math.max(0, Math.min(5, rating)) * starWidth;
        var starSpan = document.createElement('span');
        starSpan.style.width = width + 'px';
        element.innerHTML = '';
        element.appendChild(starSpan);
    });
}
function displayTimeAgo(contentDate) {
    var currentDate = new Date();
    var newDate = new Date(contentDate * 1000);
    // @ts-ignore
    var timeDifference = currentDate - newDate;
    var daysAgo = Math.floor(timeDifference / (24 * 60 * 60 * 1000));
    var weeksAgo = Math.floor(daysAgo / 7);
    var monthsAgo = Math.floor(weeksAgo / 4);
    if (monthsAgo > 0) {
        return monthsAgo === 1 ? '1 month ago' : "".concat(monthsAgo, " months ago");
    }
    else if (weeksAgo > 0) {
        return weeksAgo === 1 ? '1 week ago' : "".concat(weeksAgo, " weeks ago");
    }
    else {
        return (daysAgo === 1 || daysAgo === 0) ? '1 day ago' : "".concat(daysAgo, " days ago");
    }
}
function handleReadMore(index) {
    var reviewItems = document.querySelectorAll('.google-reviews .review-item[data-index="' + index + '"]');
    for (var index_1 = 0; index_1 < reviewItems.length; index_1++) {
        var reviewItem = reviewItems[index_1];
        var p = reviewItem.querySelector('p');
        var span = reviewItem.querySelector('p span');
        var button = reviewItem.querySelector('button');
        if (p && span && button) {
            var shortText = p.getAttribute("data-short-text") || '';
            var dataText = p.getAttribute('data-text') || '';
            if (button.textContent === "Read more") {
                span.textContent = dataText;
                button.textContent = "Read less";
            }
            else {
                span.textContent = shortText;
                button.textContent = "Read more";
            }
        }
    }
}
